import {
	AppBar,
	IconButton,
	Tab,
	Tabs,
	Toolbar,
	Typography,
} from "@mui/material"
import React, { FC, useEffect, useState } from "react"
import LightModeIcon from "@mui/icons-material/LightMode"
import LanguageIcon from "@mui/icons-material/Language"
import { ColorModeContext } from "../theme/theme"
import { useLocation, useNavigate } from "react-router-dom"
import { findTab } from "../utils/utils"

const items = [
	{ title: "ГЛАВНАЯ", to: "/home" },
	{ title: "КОНТАКТЫ", to: "/contacts" },
	{ title: "F.A.Q.", to: "/faq" },
]

const NavBar: FC = () => {
	const colorMode = React.useContext(ColorModeContext)
	const { pathname } = useLocation()
	const navigate = useNavigate()
	const [currentTab, changeTab] = useState<string>(findTab(pathname, items))

	useEffect(() => {
		changeTab(findTab(pathname, items))
	}, [pathname])

	const handleChange = (event: React.SyntheticEvent, path: string) => {
		// setValue(newValue)
		// changeTab(newValue)
		navigate(path)
	}

	return (
		<AppBar position="static" sx={{ marginBottom: "10px" }}>
			<Toolbar>
				<IconButton onClick={() => navigate("/home")}>
					<LanguageIcon />
				</IconButton>
				<Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
					ГЕОЗЕМПЛАН
				</Typography>
				<Tabs
					value={currentTab}
					onChange={handleChange}
					aria-label="navigation"
					// sx={{ marginLeft: 2 }}
				>
					{items.map((item) => {
						return <Tab key={item.title} label={item.title} value={item.to} />
					})}
					{/* <Tab label="ГЛАВНАЯ" value="1" />
					<Tab label="КОНТАКТЫ" value="2" />
					<Tab label="F.A.Q." value="3" /> */}
				</Tabs>
				<IconButton
					size="large"
					edge="start"
					color="inherit"
					aria-label="menu"
					sx={{ mr: 2 }}
					onClick={colorMode.toggleColorMode}
				>
					<LightModeIcon />
				</IconButton>
			</Toolbar>
		</AppBar>
	)
}

export default NavBar
